import { isShitScheduledToday, isShitScheduledThisMonth, isShitScheduledThisWeek } from '../constants/shit-functions'

export const scheduleTypes = {
  SCHEDULE_ANY: 'Any',
  SCHEDULE_NONE: 'None',
  SCHEDULE_TODAY: 'Today',
  SCHEDULE_THIS_WEEK: 'This Week',
  SCHEDULE_THIS_MONTH: 'This Month'
}

export const scheduleFilters = {
  [scheduleTypes.SCHEDULE_ANY]: () => {
    return true
  },
  [scheduleTypes.SCHEDULE_NONE]: (shit) => {
    return !shit.scheduledAt
  },
  [scheduleTypes.SCHEDULE_TODAY]: (shit) => {
    return isShitScheduledToday(shit)
  },
  [scheduleTypes.SCHEDULE_THIS_WEEK]: (shit) => {
    return isShitScheduledThisWeek(shit)
  },
  [scheduleTypes.SCHEDULE_THIS_MONTH]: (shit) => {
    return isShitScheduledThisMonth(shit)
  }
}
